import React, { useEffect, useState } from "react";
// import { withRouter } from "react-router";
//scss
import "./Dashboard.scss";
//component
import TravelServices from "./TravelServices";
import StaticPart from "./StaticPart";
import SearchForm from "./SearchForm";
import Carousal from "./Carousal";
import language from "../../../language";
//mui
import Grid from "@mui/material/Grid";

//assets
import PackageForm from "./PackageForm";
import BuslistingHomeSlider from "../BusListing2/BuslistingHomeSlider";

const Dashboard = (props) => {
  const [selected, setSelected] = React.useState("Bus Ticket");
  const [packageTrip, setPackageTrip] = React.useState(false);
  const [otherPackage, setOtherPackage] = React.useState(false);
  const [showFirstText, setShowFirstText] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowFirstText((prev) => !prev); // toggle between true/false
    }, 7500); // 7 seconds

    return () => clearInterval(interval); // cleanup
  }, []);


  const setTrip = (e) => {

    if (
      e === "Umrah" ||
      e === "Madinah Ziyarah" ||
      e === "Umrah & Madinah Ziyarah" ||
      e === "Visa Package"
    ) {
      setPackageTrip(true);
      setOtherPackage(false);
      setSelected(e);
    } else if (
      e === "Visa Services" ||
      e === "Cargo Service" ||
      e === "Hajj" ||
      e === "Tourism" ||
      e === "Bus Rental"
    ) {
      setPackageTrip(false);
      setOtherPackage(true);
      setSelected(e);
    } else {
      setPackageTrip(false);
      setOtherPackage(false);
      setSelected(e);
    }
  }


  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
      !sessionStorage.getItem("language")
      ? true
      : false;
  return (
    <>
      <Grid container className="LandingWrapper">
        <div className="sliderWrapperHome">
          <BuslistingHomeSlider />
        </div>
        <Grid container className="form-wrapper">
          <Grid container className="homehero">
            <Grid item xs={12} className="homeHeadexplore">
              {/* <div style={{ display: "flex", flexDirection: "column" }}>
                <h1 className="title-home">
                  {showFirstText
                    ? languageSelectedEnglish
                      ? "Explore Saudi Arabia !!!"
                      : language.exploreYemen
                    : languageSelectedEnglish
                      ? "Explore UAE !!!"
                      : language.exploreUAE}
                </h1>
                <p className="subtitle-home">
                  {showFirstText
                    ? languageSelectedEnglish
                      ? "Visit amazing places from Desert Dreams to Urban Elegance..."
                      : language.visitAmazingPlaces
                    : languageSelectedEnglish
                      ? "From Desert Dreams to Urban Elegance..."
                      : language.visitAmazingPlaces2}
                </p>
              </div> */}
            </Grid>
            <Grid container xs={12} className="categories">
              <Grid
                item
                className={`${selected === "Bus Ticket" ? "selected" : ""} category-item`}
                onClick={() => setTrip("Bus Ticket")}
              >
                <p>
                  {languageSelectedEnglish ? "Bus Tickets" : language.busTicket}
                </p>
              </Grid>
              <Grid
                item
                className={`${selected === "Umrah" ? "selected" : ""
                  } category-item`}
                onClick={() => setTrip("Umrah")}
              >
                <p>{languageSelectedEnglish ? "Umrah" : language.umrah}</p>
              </Grid>
              <Grid
                item
                className={`${selected === "Madinah Ziyarah" ? "selected" : ""
                  } category-item`}
                onClick={() => setTrip("Madinah Ziyarah")}
              >
                <p>{languageSelectedEnglish ? "Madinah Ziyarah" : language.umrah}</p>
              </Grid>
              <Grid
                item
                className={`${selected === "Umrah & Madinah Ziyarah" ? "selected" : ""
                  } category-item`}
                onClick={() => setTrip("Umrah & Madinah Ziyarah")}
              >
                <p>{languageSelectedEnglish ? "Umrah & Madinah Ziyarah" : language.umrah}</p>
              </Grid>
              <Grid
                item
                className={`${selected === "Visa Package" ? "selected" : ""
                  } category-item`}
                onClick={() => setTrip("Visa Package")}
              >
                <p>{languageSelectedEnglish ? "Visa Package" : language.umrah}</p>
              </Grid>
              <Grid
                item
                className={`${selected === "Visa Services" ? "selected" : ""
                  } category-item`}
                onClick={() => setTrip("Visa Services")}
              >
                <p>
                  {languageSelectedEnglish
                    ? "Visa Services"
                    : language.visaServices}
                </p>
              </Grid>
              <Grid
                item
                className={`${selected === "Cargo Service" ? "selected" : ""
                  } category-item`}
                onClick={() => setTrip("Cargo Service")}
              >
                <p>
                  {languageSelectedEnglish
                    ? "Cargo Service"
                    : language.cargoServices}
                </p>
              </Grid>
              <Grid
                item
                className={`${selected === "Hajj" ? "selected" : ""
                  } category-item`}
                onClick={() => setTrip("Hajj")}
              >
                <p>{languageSelectedEnglish ? "Hajj" : language.hajj}</p>
              </Grid>
              <Grid
                item
                className={`${selected === "Tourism" ? "selected" : ""
                  } category-item`}
                onClick={() => setTrip("Tourism")}
              >
                <p>{languageSelectedEnglish ? "Tourism" : language.tourism}</p>
              </Grid>
              <Grid
                item
                className={`${selected === "Bus Rental" ? "selected" : ""
                  } category-item`}
                onClick={() => setTrip("Bus Rental")}
              >
                <p>
                  {languageSelectedEnglish ? "Bus Rental" : language.busRental}
                </p>
              </Grid>
            </Grid>
            <Grid container xs={12} className="BookingContainer">
              <Grid item className="inputCardsWrapper">
                <Grid container className="CardsContainer">
                  <Grid
                    item
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="placeWrapper"
                  >
                    <p className="heading">
                      {selected === "Bus Ticket"
                        ? languageSelectedEnglish
                          ? "Book Your Bus Ticket"
                          : language.bookYourBusTicket
                        : null}
                      {selected === "Umrah"
                        ? languageSelectedEnglish
                          ? "Book your Umrah Package"
                          : language.getYourUmrahServiceToSaudiArabia
                        : null}
                      {selected === "Madinah Ziyarah"
                        ? languageSelectedEnglish
                          ? "Book your Madinah Ziyarah Package"
                          : language.getYourUmrahServiceToSaudiArabia
                        : null}
                      {selected === "Umrah & Madinah Ziyarah"
                        ? languageSelectedEnglish
                          ? "Book your Umrah & Madinah Ziyarah Package"
                          : language.getYourUmrahServiceToSaudiArabia
                        : null}
                      {selected === "Visa Package"
                        ? languageSelectedEnglish
                          ? "Book your Visa Package"
                          : language.getYourUmrahServiceToSaudiArabia
                        : null}
                      {selected === "Visa Services"
                        ? languageSelectedEnglish
                          ? "Get your Visa to Saudi Arabia"
                          : language.getYourVisaToSaudiArabia
                        : null}
                      {selected === "Cargo Service"
                        ? languageSelectedEnglish
                          ? "Get your Cargo Service to Saudi Arabia"
                          : language.getYourCargoServiceToSaudiArabia
                        : null}
                      {selected === "Hajj"
                        ? languageSelectedEnglish
                          ? "Get your Hajj Service to Saudi Arabia"
                          : language.getYourHajjServiceToSaudiArabia
                        : null}
                      {selected === "Tourism"
                        ? languageSelectedEnglish
                          ? "Get your Tourism Service to Saudi Arabia"
                          : language.getYourTourismServiceToSaudiArabia
                        : null}
                      {selected === "Bus Rental"
                        ? languageSelectedEnglish
                          ? "Bus Rental"
                          : language.busRental
                        : null}
                    </p>
                    {selected === "Bus Ticket" ? <SearchForm /> : null}
                    {packageTrip && <PackageForm packageTrip={packageTrip} service={selected} />}
                    {otherPackage && <TravelServices service={selected} />}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} align="center" className="grabTextOuter">
                <h2 className="free-ticket">
                  {languageSelectedEnglish
                    ? "Grab your Free Tickets!!"
                    : language.grabYourFreeTickets}
                </h2>
                <p className="free-details">
                  {languageSelectedEnglish
                    ? "Every 10th ticket issued by our website is free"
                    : language.every10thTicket}
                  ,{" "}
                  <span style={{ color: "#C79638" }}>
                    {languageSelectedEnglish
                      ? "Click here"
                      : language.clickHere}
                  </span>{" "}
                  {languageSelectedEnglish
                    ? "to see the daily lucky winners from the past"
                    : language.toSeeTheDailyLuckyWinners}
                </p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Carousal />
        {/* <DashboardCoupon /> */}
        <StaticPart />
      </Grid>
    </>
  );
};

export default Dashboard;
